import { render, staticRenderFns } from "./FileDash.vue?vue&type=template&id=3d9a6396&scoped=true"
import script from "./FileDash.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FileDash.vue?vue&type=style&index=0&id=3d9a6396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a6396",
  null
  
)

export default component.exports